import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FishRatingConfig } from './rating-config';

import { FishRating } from './rating';

export { FishRating } from './rating';
export { FishRatingConfig } from './rating-config';


export class FishRatingModule {
  static forRoot(): ModuleWithProviders { return { ngModule: FishRatingModule, providers: [FishRatingConfig] }; }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{ declarations: [FishRating], exports: [FishRating], imports: [CommonModule] }, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
